module.exports = __webpack_public_path__ + "img/arrow-right.32537ed2.svg";